import { useState } from 'react';

// Custom hook for managing single alert state
export const useGridCustomAlert = () => {
  const [alert, setAlert] = useState({
    isOpen: false,
    type: null, // 'payerExcluded', 'general', 'notification', 'comment', 'error', 'error837', 'facility', 'automation'
    title: '',
    message: '',
    data: null, // for any additional data needed
    onConfirm:null,
    onCancel:null,
  });

  const showAlert = (type, title = '', message = '', data = null,onConfirm=null,onCancel=null) => {
    setAlert({
      isOpen: true,
      type,
      title,
      message,
      data,
      onConfirm,
      onCancel,
    });
  };

  const hideAlert = () => {
    setAlert({
      isOpen: false,
      type: null,
      title: '',
      message: '',
      data: null,
      onConfirm:null,
      onCancel:null,
    });
  };

  return {
    alert,
    showAlert,
    hideAlert,
  };
};